import { useMatrixDistributionContext, useMatrixSettingsContext } from '@app/components/products/ProductMatrix/context';
import { MatrixHelpIcon } from '@app/components/products/ProductMatrix/MatrixHelp';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { RegularHeaderCell } from '../MatrixCells/RegularHeaderCell';

import { InputHeadCells } from './InputHeadCells';
import { PrepacksHeadCells } from './PrepacksHeadCells';
import { TotalsSummaryHeadCell } from './TotalsSummaryHeadCell';
import { TwoDimensionalHeadCell } from './TwoDimensionalHeadCell';
import { VariantHeadCells } from './VariantHeadCells';

export const MatrixHead = React.memo(() => {
  const { isDesktop, isReadOnly } = useMatrixSettingsContext();
  const { shouldHideDistributionColumn } = useMatrixDistributionContext();
  const { t } = useTranslation(['orders']);

  return (
    <thead>
      <tr data-testid="matrixHeadRow">
        {isDesktop && (
          <>
            <VariantHeadCells />
            <RegularHeaderCell className="inline-flex items-center gap-1 whitespace-nowrap pr-4 text-left">
              {!isReadOnly && (
                <>
                  {t('orders:fill_in_the_units_below')}: <MatrixHelpIcon />
                </>
              )}
            </RegularHeaderCell>
          </>
        )}
        <PrepacksHeadCells />
        {!shouldHideDistributionColumn && <RegularHeaderCell />}
        <TwoDimensionalHeadCell />
        <InputHeadCells />
        <TotalsSummaryHeadCell />
      </tr>
    </thead>
  );
});
